import { render } from "./IVS.vue?vue&type=template&id=89613dfa&scoped=true"
import script from "./IVS.vue?vue&type=script&lang=js"
export * from "./IVS.vue?vue&type=script&lang=js"

import "./IVS.vue?vue&type=style&index=0&id=89613dfa&scoped=true&lang=css"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89613dfa"]])

export default __exports__